/*eslint-disable*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  Spin,
  Row,
  Col,
  Button,
  Input,
  Space,
  Modal,
  Form,
  Select,
  Popover,
  Popconfirm,
  message,
} from "antd";
import { getAllAreas } from "../Actions/areasAction";
import { getClients } from "../Actions/clientActions";
import {
  deletePropery,
  getAllInBoundProperties,
} from "../Actions/propertiesActions";
import { updatePostPropery } from "../Actions/postPropertyAction";
import MyTable from "../components/table";
import { SearchOutlined } from "@ant-design/icons";
import "./styles/clients.css";
import { debounce } from "lodash";
import useResizeObserver from "../components/useResizeObserver";
import { Controller, useForm } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
import useColumnSearch from "../Utils/useColumnSearch";
const { Title } = Typography;

const PropertyType = [
  { value: 0, label: "Flat" },
  { value: 1, label: "Pent House" },
  { value: 2, label: "Bunglow" },
  { value: 3, label: "Tenament" },
  { value: 4, label: "Duplex" },
  { value: 5, label: "Row House" },
  { value: 6, label: "Fam House" },
  { value: 7, label: "Office" },
  { value: 8, label: "Shop" },
  { value: 9, label: "Showroom" },
  { value: 10, label: "Godown" },
  { value: 11, label: "Wear House" },
  { value: 12, label: "Residential" },
  { value: 13, label: "Commercial" },
  { value: 14, label: "Agriculture" },
  { value: 15, label: "NonAgriculture" },
  { value: 16, label: "Redevelopment" },
];

const InBoundProperties = ({ currentUser }) => {
  const dispatch = useDispatch();
  const { properties, isGetPropertiesLoading, isDeletePropertyLoading } = useSelector((state) => {
    const { properties, isGetPropertiesLoading, isDeletePropertyLoading } = state.properties;
    const { areas } = state.areas;
    const { clients } = state.clients;
    return {
      areas,
      clients,
      properties,
      isGetPropertiesLoading,
      isDeletePropertyLoading
    };
  });
  useEffect(() => {
    dispatch(getAllInBoundProperties(true));
    dispatch(getClients());
    dispatch(getAllAreas());
  }, []);

  return (
    <Spin className="create_client_field" spinning={isGetPropertiesLoading || isDeletePropertyLoading}>
      {properties && (
        <AllInBoundProperties data={properties} currentUser={currentUser} />
      )}
    </Spin>
  );
};
export default InBoundProperties;

const AllInBoundProperties = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const { areas } = useSelector((state) => state.areas);
  const { clients } = useSelector((state) => state.clients);
  const [CurrentInboundProperty, setCurrentInboundProperty] = useState({});
  const [size, setSize] = useState({ width: 0, height: 0 });
  const onRowSelect = (record) => {
    setCurrentInboundProperty(record);
  };

  const columns = (areas, clients) => [
    ...(props.currentUser?.role === "Admin"
      ? [
          {
            title: "Client Name",
            dataIndex: "client_name",
            key: "1",
            width: 120,
            ...getColumnSearchProps("client_name"),
            render: (record) => (
              <Row justify="left">
                <Col>
                  <Typography style={{ color: "#1677ff" }}>{record || '-'}</Typography>
                </Col>
              </Row>
            ),
          },
        ]
      : []),
    // {
    //   title: "Client Name",
    //   dataIndex: "client_name",
    //   key: "1",
    //   width: 120,
    //   fixed: "left",
    //   ...getColumnSearchProps("client_name"),
    //   render: (record, object) => {
    //     return (
    //       <Row justify="left">
    //         <Col>
    //           <Typography style={{ color: "#1677ff" }}>{record}</Typography>
    //         </Col>
    //       </Row>
    //     );
    //   },
    // },
    {
      title: "Area name",
      dataIndex: "area_name",
      key: "2",
      width: 100,
      // fixed: "left",
      render: (record, object) => {
        return <div>{record || '-'}</div>;
      },
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "2",
      width: 100,
      // fixed: "left",
      render: (record, object) => {
        return <div>{record?.name || '-'}</div>;
      },
      // filters:
      //   areas &&
      //   areas.length > 0 &&
      //   areas.map((area, index) => {
      //     return { text: area.name, value: area.name };
      //   }),
      // onFilter: (value, record) => {
      //   return record.area.name.indexOf(value) === 0;
      // },
    },
    {
      title: "Property",
      dataIndex: "property_type",
      key: "3",
      width: 100,
      ...getColumnSearchProps("property_type"),
      render: (record) => {
        return <div>{record || '-'}</div>;
      },
    },
    // {
    //   title: "Total Cost",
    //   dataIndex: "cost",
    //   key: "11",
    //   width: 100,
    //   render: (cost) => {
    //     if (cost == null) return null;
    //     const formattedCost = new Intl.NumberFormat("en-IN", {
    //       style: "currency",
    //       currency: "INR",
    //       maximumFractionDigits: 0,
    //     }).format(cost);

    //     return <div>{formattedCost.replace("₹", "₹ ")}</div>;
    //   },
    //   sorter: (a, b) => a.cost - b.cost,
    // },
    {
      title: "Entry Date",
      dataIndex: "created_at",
      key: "12",
      width: 100,
      sorter: (a, b) => a.created_at - b.created_at,
      render: (record) => {
        return <div>{record || '-'}</div>;
      },
    },
    // {
    //   title: "Last communication date",
    //   dataIndex: "last_communication_date",
    //   key: "13",
    //   width: 100,
    //   sorter: (a, b) => a.last_communication_date - b.last_communication_date,
    // },
    // {
    //   title: "BHK",
    //   dataIndex: "bhk",
    //   key: "14",
    //   width: 100,
    //   sorter: (a, b) => a.bhk - b.bhk,
    // },
    // {
    //   title: "Floor",
    //   dataIndex: "floor",
    //   key: "15",
    //   width: 100,
    //   sorter: (a, b) => a.floor - b.floor,
    // },
    // {
    //   title: "Total Floor",
    //   dataIndex: "total_floor",
    //   key: "16",
    //   width: 100,
    //   sorter: (a, b) => a.total_floor - b.total_floor,
    // },
    // {
    //   title: "Property No.",
    //   dataIndex: "unique_number",
    //   key: "17",
    //   width: 100,
    // },
    {
      title: "Address",
      dataIndex: "address",
      key: "18",
      width: 100,
      render: (record) => {
        return <div>{record || '-'}</div>;
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "18",
      width: 100,
      render: (record) => {
        return <div>{record || '-'}</div>;
      },
    },
    {
      title: "id",
      width: 80,
      dataIndex: "id",
      key: "19",
      ...getColumnSearchProps("id"),
      render: (record) => {
        return <div>{record || '-'}</div>;
      },
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 130,
      render: (id) => <ActionComponent id={id} />,
    },
  ];
  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== size.width || newHeight !== size.height) {
        setSize({ width: newWidth, height: newHeight });
      }
    }, 200),
    [size]
  );
  useResizeObserver(handleResize);

  return (
    <>
      <Row className="rowWithPadding">
        <Col>
          <Title level={4} className="title_all_clients">
            Inbound Properties({props.data.length})
          </Title>
        </Col>
      </Row>
      <MyTable
        columns={columns(areas, clients)}
        data={props.data}
        onRowSelect={(record) => onRowSelect(record)}
      />
    </>
  );
};
const ActionComponent = ({ id }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const { postProperties, isUpdatePostPropertyLoading } = useSelector(
    (state) => state.postProperties
  );
  const { areas } = useSelector((state) => state.areas);
  const { properties } = useSelector((state) => state.properties);
  const the_postProperty = properties?.find(
    (postProperty) => String(postProperty.id) === String(id)
  );

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...the_postProperty,
      name: the_postProperty?.client?.name || "",
      email: the_postProperty?.client?.email || "",
      mobile_number: the_postProperty?.client?.mobile_number || "",
      area_id: the_postProperty?.area?.id || null,
    },
  });

  useEffect(() => {
    if (the_postProperty) {
      reset({
        ...the_postProperty,
        name: the_postProperty?.client?.name || "",
        email: the_postProperty?.client?.email || "",
        mobile_number: the_postProperty?.client?.mobile_number || "",
        area_id: the_postProperty?.area?.id || null,
      });
    }
  }, [the_postProperty, reset]);

  const handleModalOpen = () => {
    setPopoverVisible(false);
    setIsModalOpen(true);
  };
  const handleModalClose = () => setIsModalOpen(false);

  const handlePostProperty = (data) => {
    const payload = {
      id,
      property: {
        address: data?.address || "",
        area_id: data?.area_id || "",
        area_name: data?.area_name || "",
        city: data?.city || "",
        landmark: data?.landmark || "",
        details: data?.details || "",
        property_type: data?.property_type || "",
      },
      client: {
        name: data.name || "",
        email: data.email || "",
        mobile_number: data.mobile_number || "",
      },
    };
    dispatch(updatePostPropery(payload, handleModalClose));
  };

  const handleUpdateProperty = () => {
    dispatch(
      updatePostPropery({
        id,
        property: { inbound_property: false },
      })
    );
  };

  const handleDeleteInboundProperty = (id) => {
    dispatch(
      deletePropery(
        id,
        null,
        successDeleteInboundProperty,
        failureDeleteInboundProperty
      )
    );
  };

  const successDeleteInboundProperty = () => {
    dispatch(getAllInBoundProperties(true));
    message.success("Inbound Property deleted successfully");
  };

  const failureDeleteInboundProperty = () => {
    message.error("Failed to delete Inbound Property");
  };

  const content = (
    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
      <Typography
        style={{ color: "#1677ff", cursor: "pointer" }}
        onClick={handleModalOpen}
      >
        Edit
      </Typography>
      <Typography
        style={{
          color: the_postProperty?.area?.id ? "#1677ff" : "gray",
          cursor: the_postProperty?.area?.id ? "pointer" : "not-allowed",
          opacity: the_postProperty?.area?.id ? 1 : 0.6,
        }}
        onClick={() => {
          if (the_postProperty?.area?.id) {
            handleUpdateProperty();
            setPopoverVisible(false);
          }
        }}
      >
        Move to Property
      </Typography>
      <Popconfirm
        title="Sure to delete?"
        // onConfirm={() => dispatch(deletePropery(id, type))}
        onConfirm={() => handleDeleteInboundProperty(id)}
      >
        <Typography
          style={{ color: "#1677ff", cursor: "pointer" }}
          onClick={() => setPopoverVisible(false)}
        >
          Delete
        </Typography>
      </Popconfirm>
    </div>
  );

  return (
    <>
      <Popover
        content={content}
        open={popoverVisible}
        trigger="click"
        onOpenChange={setPopoverVisible}
      >
        <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
          Action
        </Button>
      </Popover>

      <Modal
        title="Edit Inbound Property"
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
        // width={600}
        // destroyOnClose
      >
        <Spin spinning={isUpdatePostPropertyLoading}>
          <form onSubmit={handleSubmit(handlePostProperty)}>
            <Row justify="left" gutter={[0, 20]}>
              <Col span={24}>
                <Row gutter={[20, 20]}>
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{ pointerEvents: "none", opacity: 0.6 }}
                  >
                    <Typography className="formHeading">Full name</Typography>
                    <Controller
                      as={Input}
                      name="name"
                      control={control}
                      placeholder="Enter your name"
                    />
                  </Col>
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{ pointerEvents: "none", opacity: 0.6 }}
                  >
                    <Typography className="formHeading">
                      Email Address
                    </Typography>
                    <Controller
                      as={Input}
                      name="email"
                      control={control}
                      placeholder="Enter your Email"
                    />
                  </Col>
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{ pointerEvents: "none", opacity: 0.6 }}
                  >
                    <Typography className="formHeading">
                      Phone number
                    </Typography>
                    <Controller
                      as={Input}
                      name="mobile_number"
                      type="number"
                      control={control}
                      placeholder="Enter your phone number"
                    />
                  </Col>
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{
                      textAlign: "left",
                    }}
                  >
                    <Typography className="formHeading">
                      Property type
                    </Typography>
                    <Controller
                      as={Select}
                      control={control}
                      options={PropertyType.map((val) => ({
                        label: val.label,
                        value: val.value + 1,
                      }))}
                      name="property_type"
                      placeholder="Select Property Type"
                      style={{ width: "100%", marginBottom: "8px" }}
                    />
                    {errors?.property?.property_type?.message && (
                      <span className="error_style">
                        {errors?.property?.property_type?.message}
                      </span>
                    )}
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Typography className="formHeading">Address</Typography>

                    <Controller
                      as={Input}
                      name="address"
                      control={control}
                      placeholder="Enter address "
                    />
                    {errors.address && (
                      <span className="error_style">Address is required</span>
                    )}
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Typography className="formHeading">Landmark</Typography>

                    <Controller
                      as={Input}
                      name="landmark"
                      control={control}
                      placeholder="Enter landmark"
                    />
                    {errors.landmark && (
                      <span className="error_style">Landmark is required</span>
                    )}
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Typography className="formHeading">Area name</Typography>

                    <Controller
                      as={Input}
                      name="area_name"
                      control={control}
                      placeholder="Enter area"
                    />
                    {errors?.property?.area_name?.message && (
                      <span className="error_style">Area is required</span>
                    )}
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Typography className="formHeading">Area</Typography>
                    <Controller
                      as={Select}
                      control={control}
                      showSearch
                      options={
                        areas &&
                        areas.length > 0 &&
                        areas.map((val, index) => {
                          return { label: val.name, value: val.id };
                        })
                      }
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: "100%" }}
                      name="area_id"
                      placeholder="Enter area"
                    />
                    {errors?.area_id && (
                      <span className="error_style">Area is required</span>
                    )}
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Typography className="formHeading">City</Typography>
                    <Controller
                      as={Input}
                      name="city"
                      control={control}
                      placeholder="Enter city name"
                    />
                    {errors.city && (
                      <span className="error_style">City is required</span>
                    )}
                  </Col>
                  <Col span={24}>
                    <Typography className="formHeading">Comments</Typography>
                    <Controller
                      as={TextArea}
                      name="details"
                      placeholder="Enter any other details about property"
                      control={control}
                      rows={4}
                    />
                  </Col>
                </Row>
              </Col>

              <Col span={24} style={{ textAlign: "center" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="submitFormButton"
                >
                  Update form
                </Button>
              </Col>
            </Row>
          </form>
        </Spin>
      </Modal>
    </>
  );
};
